import { AxiosResponse } from 'axios';
import { environment } from '@environment';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';

export type SiteConfig = {
  CountryName: string;
  CountryCode: string;
  AlternateCountryCode: string;
  Language: string;
  Currency: string;
  CurrencyCode: string;
  AlternateCurrency: string;
  AlternateCurrencyCode: string;
  SwitchCurrency: boolean;
};
export class UmbracoConfigService {
  private static apiBuilder = new EndpointHelper(`${environment.UMBRACO_BASE_URI}`);

  static getSiteConfig(countryCode: string = 'za'): Promise<SiteConfig> {
    const url = this.apiBuilder
      .createUrl('web-settings')
      .addBaseRouteParam(`en-${countryCode}/local-site-configuration`)
      .addRouteParam('ujson')
      .addQueryParam('children', 'SiteInfo')
      .addQueryParam('select', 'CountryName,Currency,CurrencyCode,AlternateCurrency,CurrencyCode,AlternateCurrencyCode,CountryCode,AlternateCountryCode,SwitchCurrency')
      .addQueryParam('noCache', true)
      .build();

    return HttpClient.GetInstance.get<SiteConfig>(url).then((res: AxiosResponse<any>) => res?.data?.properties);
  }
}